enum MOTIVATE {
  LOSE_WEIGHT = "Lose Weight",
  LEARN_TO_DANCE = "Learn to Dance",
  GET_TONED = "Get Toned",
  FEEL_HAPPIER = "Feel Happier",
}

export default MOTIVATE;
